import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps, mapProps } from 'recompose';

import withMe from '../containers/withMe';
import { withUser } from '../../app/containers';
import withStaffingCompanyGroup from '../containers/withStaffingCompanyGroup';

import requireProps from '../../app/lib/requireProps';

import PhoneNumber from '../../app/components/PhoneNumber/PhoneNumber';

import { UserRecord } from '../../app/entities/records';
import { useTranslation } from 'react-i18next';

function Footer({ user, staffingCompanyPhone }) {
  const { ownerName, ownerPhone, ownerEmail } = user ? user.toJS() : {};

  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="container-fluid">
        {ownerName && <span>{t("Din konsultchef")}: {ownerName}</span>}
        {ownerPhone && (<span>,&nbsp;<PhoneNumber>{ownerPhone}</PhoneNumber></span>)}
        {ownerEmail && (
          <span>
            ,&nbsp;<a href={`mailto:${ownerEmail}`} title={`mailto:${ownerEmail}`}>{ownerEmail}</a>
          </span>
        )}
        {staffingCompanyPhone && (
          <span>&nbsp; {t("Växelnummer")}: <PhoneNumber>{staffingCompanyPhone}</PhoneNumber></span>
        )}
        <span className="text-muted pull-right">
          {t("Powered by")}&nbsp;
          <a href="http://leanlink.io" rel="noopener noreferrer" target="_blank">
            LeanLink
          </a>
        </span>
      </div>
    </footer>
  );
}

Footer.defaultProps = {
  user: undefined,
  staffingCompanyPhone: undefined,
};

Footer.propTypes = {
  user: PropTypes.instanceOf(UserRecord),
  staffingCompanyPhone: PropTypes.string,
};

export default compose(
  withMe,
  withStaffingCompanyGroup,
  requireProps(['resource'], true),
  withProps(({ resource }) => ({
    userId: resource.get('owningUser'),
  })),
  withUser,
  requireProps(['staffingCompanyGroup'], true),
  mapProps(({ resource, user, staffingCompanyGroup }) => ({
    user,
    initialValues: resource,
    staffingCompanyPhone: staffingCompanyGroup.get('phone'),
  })),
)(Footer);
